import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { FuelProductsContribution } from '../../../../../../components/widgets/airport/providers/provider-products/fuel-products/fuel-product-contributions/fuel-products-contribution';
import { connectNLP } from '../../../../../../utilities/connect-navigate';
import { Contributions } from '../../contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class SubFuelContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/fuelproducts/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return 'products';
	}

	public getModalEndpoint() {
		return `/fuelproducts/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<FuelProductsContribution
				close={() => this.onModalClose()}
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				original={get(ctx.state, 'response')}
			/>
		);
	}
}

export const SubFuelContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(SubFuelContributionsComponent));
